module.exports = __webpack_public_path__ + "static/media/dashboard.f6d0d156.png";